import React from 'react';
interface CardProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
  actions?: React.ReactNode;
  noPadding?: boolean;
  variant?: 'default' | 'bordered' | 'elevated';
  isHoverable?: boolean;
  isInteractive?: boolean;
  onClick?: () => void;
}
export function Card({
  title,
  children,
  className = '',
  actions,
  noPadding = false,
  variant = 'default',
  isHoverable = false,
  isInteractive = false,
  onClick
}: CardProps) {
  const variantStyles = {
    default: 'bg-white border border-gray-200 shadow-sm',
    bordered: 'bg-white border-2 border-gray-200',
    elevated: 'bg-white border border-gray-200 shadow-md'
  };
  const hoverableStyles = isHoverable ? 'transition-all duration-200 hover:shadow-md' : '';
  const interactiveStyles = isInteractive ? 'cursor-pointer active:translate-y-0.5 transition-transform duration-75' : '';
  const contentPadding = noPadding ? '' : 'p-4';
  return <div className={`rounded-lg overflow-hidden ${variantStyles[variant]} ${hoverableStyles} ${interactiveStyles} ${className}`} onClick={isInteractive ? onClick : undefined} data-id="element-3699">
      {title && <div className="px-4 py-3 border-b border-gray-200 flex justify-between items-center" data-id="element-3700">
          <h3 className="text-sm font-medium text-gray-900" data-id="element-3701">{title}</h3>
          {actions && <div data-id="element-3702">{actions}</div>}
        </div>}
      <div className={contentPadding} data-id="element-3703">{children}</div>
    </div>;
}